import { Injectable } from '@angular/core';
import { ProductModel } from '../models/product.model';

@Injectable({ providedIn: 'root' })
export class ProductService {


 private data: ProductModel[] = [
  // ========== CHEMISTRY ==========
  {
    id: 'chem-200',
    slug: 'alphatec-alpsc-100',
    name: 'ALPHATEC ALPSC® 100',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc100A.jpg',
      'assets/p/chemistry/Alpsc100fd.jpg'
    ],
    shortDesc: 'Analizador de química clínica automático.',
    salePolicy: 'QUOTE'
  },
  {
    id: 'chem-200',
    slug: 'alphatec-alpsc-200',
    name: 'ALPHATEC ALPSC® 200',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc200.jpg',
      'assets/p/chemistry/Alpsc200fd.jpg'
    ],
    shortDesc: 'Analizador de química clínica automático.',
    salePolicy: 'QUOTE'
  },
  {
    id: 'chem-400',
    slug: 'alphatec-alpsc-400',
    name: 'ALPHATEC ALPSC® 400',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc400.jpg',
      'assets/p/chemistry/Alpsc400fd.jpg'
    ],
    shortDesc: 'Analizador de química clínica automático.',
    salePolicy: 'QUOTE'
  },
  {
    id: 'chem-430',
    slug: 'alphatec-alpsc-430',
    name: 'ALPHATEC ALPSC® 430',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc430.jpg',
      'assets/p/chemistry/Alpsc430fd.jpg'
    ],
    shortDesc: 'Analizador de química clínica automático.',
    salePolicy: 'QUOTE'
  },
  {
    id: 'chem-480',
    slug: 'alphatec-alpsc-480',
    name: 'ALPHATEC ALPSC® 480',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc480f.jpg',
      'assets/p/chemistry/Alpsc480fd.jpg'
    ],
    shortDesc: 'Analizador de química clínica automático.',
    salePolicy: 'QUOTE'
  },
  {
    id: 'chem-640',
    slug: 'alphatec-alpsc-640',
    name: 'ALPHATEC ALPSC® 640',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc640f.jpg',
      'assets/p/chemistry/Alpsc640fd.jpg'
    ],
    shortDesc: 'Analizador de química clínica automático.',
    salePolicy: 'QUOTE'
  },
  {
    id: 'chem-800',
    slug: 'alphatec-alpsc-800',
    name: 'ALPHATEC ALPSC® 800',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc800f.jpg'
    ],
    shortDesc: 'Analizador de química clínica de alta capacidad.',
    salePolicy: 'QUOTE'
  },
  {
    id: 'chem-1600',
    slug: 'alphatec-alpsc-1600',
    name: 'ALPHATEC ALPSC® 1600',
    brand: 'ALPHATEC',
    categorySlug: 'chemistry',
    series: 'ALPSC®',
    images: [
      'assets/p/chemistry/Alpsc1600.jpg'
    ],
    shortDesc: 'Analizador de química clínica para grandes volúmenes.',
    salePolicy: 'QUOTE'
  },

  // ========== CENTRIFUGES (EOLO®) ==========
  {
    id: 'cen-12',
    slug: 'alphatec-eolo-12',
    name: 'ALPHATEC EOLO® 12',
    brand: 'ALPHATEC',
    categorySlug: 'centrifuges',
    series: 'EOLO®',
    images: [
      'assets/p/centrifuges/Eolo12.png',
      'assets/p/centrifuges/Eolo12d.png',
      'assets/p/centrifuges/Eolo12iz.png'
    ],
    shortDesc: 'Centrífuga de mesa 12 posiciones.',
    salePolicy: 'BOTH',
    price: 1999,
    stock: 4
  },
  // {
  //   id: 'cen-24',
  //   slug: 'alphatec-eolo-24',
  //   name: 'ALPHATEC EOLO® 24',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'centrifuges',
  //   series: 'EOLO®',
  //   images: [
  //     'assets/p/centrifuges/Eolo24.png',
  //     'assets/p/centrifuges/Eolo24 Abierta.png',
  //     'assets/p/centrifuges/Eolo24d.png',
  //     'assets/p/centrifuges/Eolo24 Izq.png',
  //     'assets/p/centrifuges/Ueolo24 Abierta.png',
  //     'assets/p/centrifuges/Ueolo24 Rotor.png'
  //   ],
  //   shortDesc: 'Centrífuga de mesa 24 posiciones.',
  //   salePolicy: 'BOTH',
  //   price: 2799,
  //   stock: 3
  // },

  // ========== HEMATOLOGY ==========
  {
    id: 'hema-36f',
    slug: 'alphatec-alpsc-36f',
    name: 'ALPHATEC ALPSC® 36F',
    brand: 'ALPHATEC',
    categorySlug: 'hematology',
    series: 'ALPSC®',
    images: [
      'assets/p/hematology/Alpsc36f.png',
      'assets/p/hematology/Alpsc36fd.png',
      'assets/p/hematology/Alpsc36fiz.png'
    ],
    shortDesc: 'Analizador hematológico automatizado.',
    salePolicy: 'QUOTE'
  },
  // {
  //   id: 'hema-51md',
  //   slug: 'alphatec-alpsc-51md',
  //   name: 'ALPHATEC ALPSC® 51Md',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'hematology',
  //   series: 'ALPSC®',
  //   images: [
  //     'assets/p/hematology/Alpsc51Md.png'
  //   ],
  //   shortDesc: 'Analizador hematológico multiparámetro.',
  //   salePolicy: 'QUOTE'
  // },
  // {
  //   id: 'hema-53pro',
  //   slug: 'alphatec-alpsc-53-pro',
  //   name: 'ALPHATEC ALPSC® 53 Pro',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'hematology',
  //   series: 'ALPSC®',
  //   images: [
  //     'assets/p/hematology/Alpsc53pro.png',
  //     'assets/p/hematology/Alpsc53prod.png'
  //   ],
  //   shortDesc: 'Analizador hematológico de alto rendimiento.',
  //   salePolicy: 'QUOTE'
  // },
  // {
  //   id: 'hema-65pro',
  //   slug: 'alphatec-65-pro',
  //   name: 'ALPHATEC 65 Pro',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'hematology',
  //   series: 'ALPSC®',
  //   images: [
  //     'assets/p/hematology/65 pro s-01.png',
  //     'assets/p/hematology/65 pro s.02.png',
  //     'assets/p/hematology/65 pro s.03.png'
  //   ],
  //   shortDesc: 'Plataforma hematológica profesional.',
  //   salePolicy: 'QUOTE'
  // },

  // ========== IMMUNOLOGY (COLOSSO®) ==========
  {
    id: 'im-100',
    slug: 'alphatec-colosso-100',
    name: 'ALPHATEC COLOSSO® 100',
    brand: 'ALPHATEC',
    categorySlug: 'immunology',
    series: 'COLOSSO®',
    images: [
      'assets/p/immunology/Colos100.png',
      'assets/p/immunology/Colos100fd.png',
      'assets/p/immunology/Colos100fiz.png'
    ],
    shortDesc: 'Analizador de inmunología automatizado.',
    salePolicy: 'QUOTE'
  },

  // ========== MICROSCOPES (ASTREO®) ==========
  {
    id: 'mic-100',
    slug: 'alphatec-astreo-100',
    name: 'ALPHATEC ASTREO® 100',
    brand: 'ALPHATEC',
    categorySlug: 'microscopes',
    series: 'ASTREO®',
    images: [
      'assets/p/microscopes/Astreo 100 F.png',
      'assets/p/microscopes/Astreo 100 ESDE.png',
      'assets/p/microscopes/Astreo 100 ESIZ.png'
    ],
    shortDesc: 'Microscopio óptico de laboratorio.',
    salePolicy: 'QUOTE'
  },
  // {
  //   id: 'mic-300',
  //   slug: 'alphatec-astreo-300',
  //   name: 'ALPHATEC ASTREO® 300',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'microscopes',
  //   series: 'ASTREO®',
  //   images: [
  //     'assets/p/microscopes/Astreo 300 F.png',
  //     'assets/p/microscopes/Astreo 300 ESDE.png',
  //     'assets/p/microscopes/Astreo 300 ESIZ.png',
  //     'assets/p/microscopes/Astreo 300LD.png',
  //     'assets/p/microscopes/Astreo 300 O.png'
  //   ],
  //   shortDesc: 'Microscopio trinocular profesional.',
  //   salePolicy: 'QUOTE'
  // },
  // {
  //   id: 'mic-300plus',
  //   slug: 'alphatec-astreo-300-plus',
  //   name: 'ALPHATEC ASTREO® 300 Plus',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'microscopes',
  //   series: 'ASTREO®',
  //   images: [
  //     'assets/p/microscopes/Astreo 300plus F.png',
  //     'assets/p/microscopes/Astreo 300plus ESDE.png',
  //     'assets/p/microscopes/Astreo 300plus ESIZ.png',
  //     'assets/p/microscopes/Astreo 300plusLD.png'
  //   ],
  //   shortDesc: 'Microscopio avanzado para investigación.',
  //   salePolicy: 'QUOTE'
  // },
  // {
  //   id: 'mic-620',
  //   slug: 'alphatec-astreo-620',
  //   name: 'ALPHATEC ASTREO® 620',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'microscopes',
  //   series: 'ASTREO®',
  //   images: [
  //     'assets/p/microscopes/Astreo 620 F.png',
  //     'assets/p/microscopes/Astreo 620 ESDE.png',
  //     'assets/p/microscopes/Astreo 620 ESIZ.png',
  //     'assets/p/microscopes/Astreo 620 O.png',
  //     'assets/p/microscopes/Astreo 620 LD.png'
  //   ],
  //   shortDesc: 'Microscopio de alto desempeño.',
  //   salePolicy: 'QUOTE'
  // },
  // {
  //   id: 'mic-1000',
  //   slug: 'alphatec-astreo-1000',
  //   name: 'ALPHATEC ASTREO® 1000',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'microscopes',
  //   series: 'ASTREO®',
  //   images: [
  //     'assets/p/microscopes/Ast1000.png'
  //   ],
  //   shortDesc: 'Microscopio para aplicaciones especializadas.',
  //   salePolicy: 'QUOTE'
  // },
  // (opcionales de microscopía si los usas)
  // {
  //   id: 'mic-tyr',
  //   slug: 'alphatec-tyr',
  //   name: 'ALPHATEC TYR®',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'microscopes',
  //   series: 'TYR®',
  //   images: [
  //     'assets/p/microscopes/AlpscTYRf.png'
  //   ],
  //   shortDesc: 'Microscopio serie TYR.',
  //   salePolicy: 'QUOTE'
  // },
  // {
  //   id: 'mic-fenrir',
  //   slug: 'alphatec-fenrir',
  //   name: 'ALPHATEC FENRIR®',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'microscopes',
  //   series: 'FENRIR®',
  //   images: [
  //     'assets/p/microscopes/AlpscFenrir.png'
  //   ],
  //   shortDesc: 'Microscopio serie FENRIR.',
  //   salePolicy: 'QUOTE'
  // },

  // ========== URINALYSIS (ALPHAQUARTZ®) ==========
  {
    id: 'uri-100',
    slug: 'alphatec-alphaquartz-100',
    name: 'ALPHATEC ALPHAQUARTZ® 100',
    brand: 'ALPHATEC',
    categorySlug: 'urinalysis',
    series: 'ALPHAQUARTZ®',
    images: [
      'assets/p/urinalysis/Alphaquartz100.png',
      'assets/p/urinalysis/Alphaquartzfd.png',
      'assets/p/urinalysis/Alphaquartz100o.png'
    ],
    shortDesc: 'Analizador de orina automatizado.',
    salePolicy: 'QUOTE'
  },
  // {
  //   id: 'uri-1k',
  //   slug: 'alphatec-alphaquartz-1k',
  //   name: 'ALPHATEC ALPHAQUARTZ® 1K',
  //   brand: 'ALPHATEC',
  //   categorySlug: 'urinalysis',
  //   series: 'ALPHAQUARTZ®',
  //   images: [
  //     'assets/p/urinalysis/Alphaquartz 1K.png',
  //     'assets/p/urinalysis/Alphaquartz 1K Der.png',
  //     'assets/p/urinalysis/Alphaquartz 1K Izq.png'
  //   ],
  //   shortDesc: 'Analizador de orina de alto rendimiento.',
  //   salePolicy: 'QUOTE'
  // }
];


  list(): ProductModel[] { return this.data; }
  byCategory(slug: string): ProductModel[] { return this.data.filter(p => p.categorySlug === slug); }
  bySlug(slug: string): ProductModel | undefined { return this.data.find(p => p.slug === slug); }
}
